import lazy from 'lazysizes';

export const lazyloadImages = () => {
    lazy.init();
};
